<template lang="pug">
  .fp-modal.fp-modal-request-data-value
    fpui-modal-header(:actions='actions', :title="title", @close='$emit("close")', @check='onConfirm')
    fpui-modal-body
      .modal-container
        label.subtitle {{'request-builder.data.compute_mode.label'|translate}} :
        br
        .compute-modes
          fpui-input-checkbox.compute-mode(
            :key='index'
            v-for="computesMod, index in computesMod",
            v-model="computesSelected[computesMod.value]"
          )
            span {{computesMod.label}}
        br
        br
        label.subtitle {{'request-builder.data.order.label'|translate}} :
        br
        .order
          fpui-input-radio(
            :options="orderValues"
            v-model="orderSelected"
          )
</template>

<script>
  export default {
    props: {
      data: String,
      confirm: Function,
      value: Array,
      order: String,
      computes: Array
    },
    data () {
      return {
        computesMod: [],
        computesSelected: {},
        orderValues: [{value: '', label: this.$t('request-builder.data.order.placeholder')}, { value: 'asc', label: this.$t('request-builder.data.order.asc') }, {value: 'desc', label: this.$t('request-builder.data.order.desc')}],
        orderSelected: '',
        actions: [{name: 'check', class: 'fpui fpui-check'}]
      }
    },
    methods: {
      onConfirm () {
        this.confirm(Object.keys(this.computesSelected).filter(key => this.computesSelected[key] === true), this.orderSelected)
        this.$emit('close')
      }
    },
    computed: {
      title () { return `${this.$t('request-builder.data')} ${this.data}` }
    },
    mounted () {
      this.computesSelected = {}
      if (this.value && this.value.length) {
        this.value.forEach(cm => {
          this.computesSelected[cm] = true
        })
      }
      this.orderSelected = this.order || ''
      this.computesMod = this.computes.sort().map(cm => ({ value: cm, label: cm }))
    }
  }
</script>

<style lang="less">
@import "~@/shared/styles/_variables.less";

.fp-modal-request-data-value {
  .modal-container {
    .order {
      text-align:center;
      .fpui-input-label-container {
        font-family: 'Roboto';
        font-size: 16px;
      }
    }
    .fpui-input-radios {
      margin-top:0;
    }
    label.subtitle {
      font-weight:bold;
      display: block;
    }
    .compute-modes {
      display: flex;
      flex-wrap: wrap;
    }
    .compute-mode {
      width:122px;
    }
  }
}

</style>
